import { IconProp } from "@fortawesome/fontawesome-svg-core"
import { faDownload, faSpinnerThird } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Box, Grid, IconButton, Stack, Typography } from "@mui/material"
import { IApiFunc, IApiResult } from "auth/interface/api.interface"
import { useApi } from "auth/useApi"
import theme from "css/theme/light"
import React, { useState } from "react"
import Moment from "react-moment"
import { getFileType } from "../helpers/getFileType"
import { IDocumentAttachment } from "../interface/folder.interface"
import { useTranslation } from "react-i18next"

const FileList = ({ attachments, downloadUrl }: any) => {
  const [clickedFileId, setClickedFile] = useState<string | null>(null)
  const { t } = useTranslation()
  const [getAttachmentResult, getAttachment] = useApi() as [IApiResult, IApiFunc]

  const downloadAttachment = React.useCallback(
    (fileId, fileName) => {
      getAttachment.getBlob(downloadUrl.replace("{id}", fileId), fileName)
    },
    [getAttachment]
  )

  return (
    <>
      <div>
        {attachments &&
          attachments.length > 0 &&
          attachments.map((attachment: IDocumentAttachment, index: number) => (
            <Box gap={2} mb={attachments.length - 1 !== index ? 1 : 0}>
              <Grid container direction="row" spacing={1} justifyContent="space-between">
                <Grid item xs="auto">
                  <FontAwesomeIcon
                    size="xs"
                    color={(theme.palette as any).primary[700]}
                    icon={getFileType(attachment.fileId) as IconProp}
                  />
                </Grid>
                <Grid item xs>
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography
                      display="inline-block"
                      variant="bodyMedium"
                      sx={{
                        "&:hover": {
                          cursor: "pointer"
                        }
                      }}
                      onClick={() => {
                        setClickedFile(attachment.fileId)
                        downloadAttachment(attachment.id, attachment.fileId)
                      }}>
                      {attachment.name}
                    </Typography>
                  </Stack>
                  <Grid container direction="row" alignItems="center" spacing={1}>
                    <Grid item display="flex" gap={1}>
                      <Typography display="flex" gap={1} variant="bodySmall" color="textSecondary">
                        {t("global.updated", "Updated")}
                      </Typography>
                      <Typography variant="bodySmall" color="textSecondary">
                        <Moment utc local format="YYYY-MM-DD">
                          {attachment.updatedDate}
                        </Moment>
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography variant="bodySmall" color="textSecondary">
                        |
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography variant="bodySmall" color="textSecondary">
                        {attachment.createdByUser?.name}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs>
                  <Stack direction="row" alignItems="center" justifyContent="flex-end" spacing={1}>
                    <IconButton
                      edge="end"
                      type="button"
                      aria-label={t("global.buttons.download", "Download")}
                      onClick={() => {
                        setClickedFile(attachment.fileId)
                        downloadAttachment(attachment.id, attachment.fileId)
                      }}>
                      <FontAwesomeIcon
                        color={theme.palette.secondary.main}
                        spin={getAttachmentResult.status === 1 && clickedFileId === attachment.fileId}
                        icon={
                          getAttachmentResult.status === 1 && clickedFileId === attachment.fileId
                            ? (faSpinnerThird as IconProp)
                            : (faDownload as IconProp)
                        }
                        size="xs"
                      />
                    </IconButton>
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          ))}
      </div>
    </>
  )
}
export default FileList
